import styled from 'styled-components';
// import colors from 'styles/colors';

import { Checkbox as FormCheckbox } from 'styles/form';

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CheckboxContent = styled(FormCheckbox)<{ size?: number }>`
  min-width: ${(props) => `${props.size ?? 17}px`};
  min-height: ${(props) => `${props.size ?? 17}px`};
  margin-right: 1em;
`;

export const CheckboxLabel = styled.div<{ uppercase: boolean }>`
  user-select: none;
  display: flex;
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : 'inherit')};
`;
